export const asiapacific = [
"Australia",
"Bangladesh",
"Bhutan",
"British Indian Ocean Territory",
"Brunei",
"Cambodia",
"China",
"Fiji",
"Hong Kong",
"India",
"Indonesia",
"Japan",
"North",
"South Korea",
"Laos",
"Macau",
"Malaysia",
"Maldives",
"Mongolia",
"Myanmar",
"Nepal",
"New Zealand",
"Pakistan",
"Papua New Guinea",
"Philippines",
"Singapore",
"Sri Lanka",
"Taiwan",
"Thailand",
"Timor-Leste",
"Vietnam"
]

export const americas = [
"Antigua and Barbuda",
"Argentina",
"Bahamas",
"Barbados",
"Belize",
"Bolivia",
"Brazil",
"Canada",
"Chile",
"Colombia",
"Costa Rica",
"Cuba",
"Dominica",
"Dominican Republic",
"Ecuador",
"El Salvador",
"Grenada	St.",
"Guatemala",
"Guyana",
"Haiti",
"Honduras",
"Jamaica",
"Mexico",
"Nicaragua",
"Panama",
"Paraguay",
"Peru",
"Saint Kitts and Nevis",
"Saint Lucia",
"Saint Vincent and the Grenadines",
"Suriname",
"Trinidad and Tobago",
"United States",
"Uruguay",
"Venezuela"
]

export const europe = [
  "Albania",
  "Andorra",
  "Austria",
  "Belarus",
  "Belgium",
  "Bosnia",
  "Bulgaria",
  "Croatia",
  "Czech Republic",
  "Denmark",
  "Estonia",
  "Finland",
  "France",
  "Germany",
  "Greece",
  "Hungary",
  "Iceland",
  "Ireland",
  "Italy",
  "Latvia",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Malta",
  "Moldova",
  "Monaco",
  "Netherlands",
  "Norway",
  "Poland",
  "Portugal",
  "Romania",
  "Russia",
  "San Marino",
  "Serbia",
  "Slovakia",
  "Slovenia",
  "Spain",
  "Sweden",
  "Switzerland",
  "Ukraine",
  "United Kingdom"
]

export const middleeast = [
  "Afghanistan",
  "Armenia",
  "Azerbaijan",
  "Bahrain",
  "Cyprus",
  "Iran",
  "Iraq",
  "Israel",
  "Jordan",
  "Kazakhistan",
  "Kuwait",
  "Kyrgyzstan",
  "Lebanon",
  "Oman",
  "Pakistan",
  "Qatar",
  "Saudi Arabia",
  "Syria",
  "Tajikistan",
  "Turkey",
  "Turkmenistan",
  "United Arab Emirates",
  "Uzbekistan",
  "Yemen"
]

export const africa = [
"Algeria",
"Angola",
"Benin",
"Botswana",
"Burkina Faso",
"Burundi",
"Cameroon",
"Cape Verde",
"Central African Republic",
"Chad",
"Democratic Republic of Congo",
"Republic of Congo",
"Cote d'Ivoire",
"Djibouti",
"Egypt",
"Equatorial Guinea",
"Eritrea",
"Ethiopia",
"Gabon",
"Gambia",
"Ghana",
"Guinea",
"Guinea Bissau",
"Kenya",
"Lesotho",
"Liberia",
"Libya",
"Madagascar",
"Malawi",
"Mali",
"Mauritania",
"Mauritius",
"Morocco",
"Mozambique",
"Namibia",
"Niger",
"Nigeria",
"Reunion",
"Rwanda",
"Sao Tome and Principe",
"Senegal",
"Seychelles",
"Sierra Leone",
"Somalia",
"South Africa",
"South Sudan",
"Sudan",
"Swaziland",
"Tanzania",
"Togo",
"Tunisia",
"Uganda",
"Zambia",
"Zimbabwe"
]



// WEBPACK FOOTER //
// ./src/components/ModalSchools/countries.js